import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../../api/DBSchema/Gateway';
import {SMCCheckbox} from '../../../../../components/Simple/SMCCheckbox';
import {useTranslation} from 'react-i18next';
import PlanEditorInnerContainer from '../../../../../components/Editor/PlanEditorInnerContainer';
import Separator from '../../../../../components/Simple/Sepperator';
import Indentation from '../../../../../components/Simple/Indentation';
import {SMCRadio, SMCRadioGroup} from '../../../../../components/Simple/SMCRadio';
import SMCLabel from '../../../../../components/Simple/SMCLabel';
import EmptyRow from '../../../../../components/Simple/EmptyRow';
import EditorLayout from '../../../../../components/Layouts/EditorLayout';
import RowLayout from '../../../../../components/Layouts/RowLayout';
import {SMCToggleSwitch} from "../../../../../components/Simple/SMCToggleSwitch";

const pageSchema = GatewayGetSchema.pages.ips;
const pageId = pageSchema.pageId;

function BaseIps({
    pageData,
    setObjectData,
    pageDisabled,
    setEditorPageId
}) {
    const { t } = useTranslation();

    const setPageValue = useCallback((param, newValue) => {
        setObjectData([pageId, param], newValue);
    }, [setObjectData]);
    
    const manageInSmp    = pageData[pageSchema.manageInSmp];
    const mode           = pageData[pageSchema.mode];
    const policy         = pageData[pageSchema.policy];
    const detectOnlyMode = pageData[pageSchema.detectOnlyMode];

    const policyValues   = pageSchema.policyValues;

    return (
        <EditorLayout>
            <SMCToggleSwitch
                disabled={pageDisabled}
                checked={manageInSmp}
                onChange={checked => setPageValue(pageSchema.manageInSmp, checked)}
                label={t('SMP.PLAN.MANAGE_IN_SMP')}
            />
            <Separator isMainSeparator/>
            <PlanEditorInnerContainer title={t('SMP.PLAN.IPS.IPS')} managedInSmp={manageInSmp}>
                <RowLayout>
                    <SMCRadioGroup value={mode ? 'ON' : 'OFF'} onChange={e => setPageValue(pageSchema.mode, e.target.value === 'ON')} disabled={pageDisabled || !manageInSmp}>
                        <SMCRadio value="ON" label={t('SMP.ON')} />
                        <SMCRadio value="OFF" label={t('SMP.OFF')} />
                    </SMCRadioGroup>
                </RowLayout>
                                
                <EmptyRow />

                <SMCLabel bold>{t('SMP.PLAN.IPS.NOTES')}</SMCLabel>
                <Indentation>
                    <SMCLabel>1. {t('SMP.PLAN.IPS.POLICY_APPLIES_ON_TEXT')}</SMCLabel>
                    <SMCLabel>2. {t('SMP.PLAN.IPS.POLICY_APPLIES_ON_OTHERS_TEXT')} <span className="Link" onClick={() => setEditorPageId(GatewayGetSchema.pages.unifiedThreatPrevention.pageId)}> {t('SMP.PLAN.UNIFIED_THREAT_PREV_POLICY')}</span></SMCLabel>
                </Indentation>

                {/* Policy */}
                <SMCLabel bold>{t('SMP.PLAN.SEC_SOFT_BLADES.POLICY')}:</SMCLabel>
                <Indentation>
                    <SMCRadioGroup value={policy} onChange={e => setPageValue(pageSchema.policy, e.target.value)} disabled={pageDisabled || !manageInSmp}>
                            <SMCRadio value={policyValues.strict} label={t('SMP.PLAN.SEC_SOFT_BLADES.STRICT')} />
                            <SMCRadio value={policyValues.standard} label={t('SMP.PLAN.IPS.TYPICAL')} />
                            <SMCRadio value={policyValues.custom} label={t('SMP.PLAN.IPS.CUSTOM')} />
                    </SMCRadioGroup>
                </Indentation>
                {/* Detect only */}
                <SMCCheckbox
                    disabled={pageDisabled || !manageInSmp}
                    checked={detectOnlyMode}
                    onChange={e => setPageValue(pageSchema.detectOnlyMode, e.target.checked)}
                    label={t('SMP.PLAN.DETECT_ONLY_MODE')}
                />

                <EmptyRow />

                <SMCLabel><b>{t('SMP.DESCRIPTION')}: </b>{t('SMP.PLAN.IPS.LINE1')}</SMCLabel>
            </PlanEditorInnerContainer>
        </EditorLayout>
    );
}

export default BaseIps;